<template>
  <div class="order-chart">
    <div class="order-table">
      <sirui-table
        ref="siruiTable"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :showToolbar="false"
        height="300"
        :setting="false"
        :customVisible="false"
        :cellStyle="cellStyle"
        :cellClick="cellClick"
        :columns="getChartColumns"
        @handleSizeChange="() => getData()"
        @handleCurrentChange="() => getData()"
      >
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in getChartColumns"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
        >
          <template slot-scope="scope">
            <span v-if="item.field == 'orderCreateDate'">
              {{ formatDateCustom(new Date(scope.row[item.field]), false) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  // import BASEAPI from '@/api/dataBase.js';
  import { chartColumns } from './index.js';
  import IntermodalityCommonMixin from '@/pages/intermodality/common/mixins/IntermodalityCommonMixin';
  export default {
    name: 'AssoContractChart',
    mixins: [IntermodalityCommonMixin],
    props: {
      projectCode: {
        type: String,
        default: () => '',
      },
    },
    data() {
      return {
        loading: false,
        tableData: [],
      };
    },
    mounted() {
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.setPageSize(10);
    },
    methods: {
      cellClick(val) {
        if (val.column?.property == 'orderCode') {
          console.log('clickOrder', val);
          this.toOrderDetail(val.row);
        }
      },
      cellStyle({ row, rowIndex, column, columnIndex }) {
        if (column.property == 'orderCode') {
          console.log('cellStyle', row, rowIndex, column, columnIndex);
          return {
            color: '#009fcc',
            cursor: 'pointer',
          };
        }
      },
      toOrderDetail(row) {
        let path = {
          path: '/intermodality/orderPage',
          name: 'orderPage',
          meta: {
            keepAlive: true,
            title: '订单详情',
          },
          query: {
            id: row.id,
            orderCode: row.orderCode,
            turnType: '1',
            orderCurrStatus: row.orderStatus,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      async getData() {
        if (!this.projectCode || !this.projectCode.length) {
          return;
        }
        let params = {
          projectCode: this.projectCode,
        };
        setTimeout(async () => {
          params.pageNum = this.$refs.siruiTable?.page?.pageNum;
          params.pageSize = this.$refs.siruiTable?.page?.pageSize;
          let data = await this.getOrderList(params);
          if (data) {
            let list = data.data.data.list;
            // let pageNum = data.data.data.pages;
            let total = data.data.data.total;
            this.tableData = list || [];
            this.$refs.siruiTable.setPageTotal(total);
          }
          console.log('orderList', data);
        }, 500);
      },
    },
    watch: {
      projectCode: {
        handler(newVal, oldVal) {
          console.log(newVal, oldVal);
          if (newVal && newVal.length && newVal != oldVal) {
            this.getData(newVal);
          }
        },
        deep: true,
        immediate: true,
      },
    },
    computed: {
      getChartColumns() {
        return chartColumns;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .contract-chart {
    background: #fff;

    .order-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
